import React from "react";
import "./HowItWorks.scss";
import { Button, Carousel } from "antd";
import Slider from "react-slick"
import { Card, Layout, Row, Col } from "antd";
import FileConstants from "../../../FileConstants";
import TextConstants from "../../../TextConstants";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { CALENDLY_LINK } from "../../../env";
import ModelViewer from "../../landingPage/sectionTwo/modelViewer";
import { buildRegisterUrl } from "../../../utils/registerRedirect";
const { Content } = Layout;

const how_it_works = [
  {
    image: "/smb/img-hiw-01@3x.jpg",
    model: true,
    poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/10911_FrontAngled.jpg",
    src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/10911.glb",
    title: "Upload product images to create a 3D model",
    text: "Start by adding your product images and details. Once your 3D model is created, you may review the quality using our simple image markup tool.",
    time: {
      'text': '24-72 hrs',
      'icon': '/smb/ClockCircle.svg'
    }
  },
  {
    image: "/smb/img-hiw-02@3x.jpg",
    contain: true,
    title: "Select product shots and design scenes",
    text: "Select multiple angles of your 3D model for product images and use Scene Creator to design scenes with your product for lifestyle images,",
    time: {
      'text': 'Minutes',
      'icon': '/smb/thunderbolt.svg'
    }
  },
  {
    image: "/smb/img-hiw-03@3x.jpg",
    cover: true,
    title: "Generate beautiful 4k imagery and more",
    text: "Now that you have 3D models, the possibilities are endless. Generate images for your listing, embed a 3D player, and add View in Room AR with a few clicks.",
    time: {
      'text': 'Minutes',
      'icon': '/smb/thunderbolt.svg'
    }
  },
];
const HowItWorks = () => {
  return (
    <>
      <WebVersion />
      <MobileVersion />
    </>
  );
};


const WebVersion = () => {
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_how_it_works`;

  return (
    <Content className="d-none d-lg-block">
      <Row className="container-fluid how-it-works-container-2">
        <Col span={24} className="justify-space-between mb-40">
          <h1 className=" manrope f-38 w-600 black-085 lh-46 mb-0">How it Works</h1>
          <Button onClick={() =>
            window.open(buildRegisterUrl(redirectPath), "_blank")
          }
            className={`manrope f-16 w-700 lh-24 blue-button`}>
            Get started for free
          </Button>
        </Col>

        <Col className="user-card-container">
          {how_it_works.map((card, index) => (
            <div className="card-wrapper">
              <Card
                className="user-card"
                cover={
                  <div className="position-relative">
                    {card.model ?
                      <div>
                        <ModelViewer class='cover-model'
                          src={card.src}
                        />
                      </div>
                      :
                      <img className="cover-image" style={{ objectFit: card.contain ? 'contain': 'cover'}} src={card.image} />}
                    <div className="manrope f-14 w-700 lh-22 card-number">{index + 1}</div>
                  </div>
                }
              >
                <div className="column">
                  <div className="d-flex align-items-baseline">
                    <h2 className="manrope f-20 w-700 black-085 lh-28 mb-16 j-sb-a-start">
                      {card.title} <span className="time-bg justify-space-between ml-16">
                        <img src={card.time.icon} />
                        <span className="manrope f-14 w-700 lh-20 dark-blue mleft-4 width-max-c">{card.time.text}</span>
                      </span>
                    </h2>
                  </div>
                  <p className="manrope f-16 w-500 black-085 lh-22">
                    {card.text}
                  </p>
                </div>
              </Card>
            </div>
          ))}
        </Col>
        <Col span={24} className="justify-in-center mt-5 text-center">
          <span className="manrope f-16 black-085 lh-24 w-700">
            Want to see how our platform works in depth?{" "}
            <a className="manrope blue" href={CALENDLY_LINK} target="_blank">
              Schedule a demo
            </a>
          </span>
        </Col>

      </Row>
    </Content>
  );
};

const MobileVersion = () => {
  const settings = {
    autoplay: false,
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1.07,
    slidesToScroll: 1,
    vertical: false,
    customPaging: i => (
      <div className="custom-dot">
        {/* &ndash;  This is the dash */}
      </div>
    ),
  };
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_how_it_works`;

  return (
    <Content className="d-lg-none">
      <Row className="container-fluid justify-in-start how-it-works-container-2">
        <Col span={24} className="justify-in-start text-left pdlr-16">
          <p className="manrope f-30 lh-40 w-600 black-085 mb-32">How it Works</p>
        </Col>
        <Col span={24} className="mb-32 pdl-12">
          <Slider {...settings} className="how-it-works-slider">
            {how_it_works.map((card, index) => (
              <div className={`card-radius-pading ${index == 0 ? `first` : ``}`} key={index}>
                <Card
                  className="user-card box"
                  style={{ paddingRight: '0px', paddingLeft: 0, marginRight: '0px' }}
                  cover={
                    <div className="position-relative">
                      {card.model ?
                        <div>
                          <ModelViewer class='cover-model'
                            src={card.src}
                          />
                        </div>
                        :
                        <img className="cover-image" style={{ objectFit: card.contain ? 'contain': 'cover'}} src={card.image} />}
                      <div className="manrope f-14 lh-22 w-700 card-number">{index + 1}</div>
                    </div>
                  }
                >
                  <div className="column">
                    <div className="d-flex align-items-baseline">
                      <h2 className="manrope f-20 black-085 w-700 mb-8">
                        {card.title}
                      </h2>
                    </div>
                    <p className="manrope f-14 w-500 black-085 mb-16 lh-22">
                      {card.text}
                    </p>
                    <div className="time-bg justify-space-between">
                      <img src={card.time.icon} />
                      <span className="manrope f-14 w-700 lh-20 dark-blue width-max-c">{card.time.text}</span>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </Slider>
        </Col>
        <Col span={24} className="pdlr-16">
          <Button block onClick={() =>
            window.open(buildRegisterUrl(redirectPath), "_blank")
          }
            className={`manrope f-16 w-700 lh-24 blue-button mb-24 w-100 centerCarousel`}>
            Get started for free
          </Button>

          <div className="mt-3 text-center">
            <span className="manrope f-16 black-085 ws-6 w-700">
              Want to see how our platform works in depth?{" "}
              <a className="manrope blue" href={CALENDLY_LINK} target="_blank">
                Schedule a demo
              </a>
            </span>
          </div>
        </Col>
      </Row>
    </Content>
  );
};
export default HowItWorks;
